function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React from 'react';
import './keywords-field.scss';
import { Form } from '@ant-design/compatible';
import '@ant-design/compatible/assets/index.css';
import { Select } from 'antd';
import { getClassNames } from '../../utils/getClassNames';
import { resolvePromiseableProp } from '../../utils/promiseable-prop';
import { useMountedRef } from '../../hooks/use-mounted-ref';
import randomstring from 'randomstring';

var TemplateKeywordsField = function TemplateKeywordsField(props) {
  var className = props.className,
      disabled = props.disabled,
      value = props.value,
      onChange = props.onChange,
      propsOptions = props.options,
      max = props.max,
      label = props.label,
      placeholder = props.placeholder,
      emptyOptionsPlaceholder = props.emptyOptionsPlaceholder,
      _props$size = props.size,
      size = _props$size === void 0 ? 'middle' : _props$size;

  var _useMountedRef = useMountedRef(),
      _useMountedRef2 = _slicedToArray(_useMountedRef, 2),
      _mounted = _useMountedRef2[0],
      runIfMounted = _useMountedRef2[1];

  var _React$useState = React.useState(randomstring.generate()),
      _React$useState2 = _slicedToArray(_React$useState, 1),
      instanceId = _React$useState2[0];

  var _React$useState3 = React.useState(),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      tmpValue = _React$useState4[0],
      setTmpValue = _React$useState4[1];

  var _React$useState5 = React.useState(false),
      _React$useState6 = _slicedToArray(_React$useState5, 2),
      keywordsLoading = _React$useState6[0],
      setKeywordsLoading = _React$useState6[1];

  var _React$useState7 = React.useState(false),
      _React$useState8 = _slicedToArray(_React$useState7, 2),
      keywordsLoaded = _React$useState8[0],
      setKeywordsLoaded = _React$useState8[1];

  var _React$useState9 = React.useState([]),
      _React$useState10 = _slicedToArray(_React$useState9, 2),
      options = _React$useState10[0],
      setOptions = _React$useState10[1];

  var workingValue = !!value ? value : tmpValue;
  React.useEffect(function () {
    // options not used when disableDropdown is enabled
    if (props.disableDropdown) {
      return;
    }

    var resolveKeywords = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var resolvedOptions;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                setKeywordsLoading(true);

                if (propsOptions) {
                  _context.next = 5;
                  break;
                }

                _context.t0 = [];
                _context.next = 8;
                break;

              case 5:
                _context.next = 7;
                return resolvePromiseableProp(propsOptions);

              case 7:
                _context.t0 = _context.sent;

              case 8:
                resolvedOptions = _context.t0;
                runIfMounted(function () {
                  setKeywordsLoaded(true);
                  setOptions(resolvedOptions);
                  setKeywordsLoading(false);
                });

              case 10:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function resolveKeywords() {
        return _ref.apply(this, arguments);
      };
    }();

    if (!keywordsLoaded && !keywordsLoading) {
      resolveKeywords();
    }
  }, [props.disableDropdown]);

  var handleKeywordChange = function handleKeywordChange(v) {
    var _workingValue$length;

    if (max !== undefined && v.length > ((_workingValue$length = workingValue === null || workingValue === void 0 ? void 0 : workingValue.length) !== null && _workingValue$length !== void 0 ? _workingValue$length : 0) && v.length > max) {
      return;
    }

    onChange === null || onChange === void 0 ? void 0 : onChange(v);
    setTmpValue(v);
  };

  return /*#__PURE__*/React.createElement(Form.Item, {
    className: getClassNames('template-keywords-field', instanceId, className, _defineProperty({}, 'dropdown-hidden', props.disableDropdown)),
    label: label
  }, /*#__PURE__*/React.createElement(Select, {
    dropdownClassName: getClassNames('template-keywords-field-dropdown', instanceId, {
      hidden: props.disableDropdown
    }),
    mode: "tags",
    disabled: disabled,
    placeholder: placeholder,
    tokenSeparators: [','],
    notFoundContent: keywordsLoading ? 'Loading keywords...' : emptyOptionsPlaceholder,
    maxTagCount: max,
    loading: keywordsLoading,
    value: workingValue !== null && workingValue !== void 0 ? workingValue : [],
    onChange: handleKeywordChange,
    size: size
  }, options.map(function (kw) {
    var _kw$label;

    return /*#__PURE__*/React.createElement(Select.Option, {
      key: kw.value,
      value: kw.value
    }, (_kw$label = kw.label) !== null && _kw$label !== void 0 ? _kw$label : kw.value);
  })));
};

export default TemplateKeywordsField;